import { gql } from '@grandvisionhq/graphql';
import { baseProductFragment } from './fragments/base-product.js';
import { baseVariantFragment } from './fragments/base-variant.js';

const GET_PRODUCTS_BY_SKUS = gql`
  query GetProductsBySKUs($skus: [String!]!) {
    getProductsBySKUs(skus: $skus) {
      ...BaseProductFragment
      variants {
        ...BaseVariantFragment
        ... on FrameVariant {
          variantTypeDetails {
            isInsuranceReimbursable
          }
        }
        ... on SolutionVariant {
          variantTypeDetails {
            contactLensCareType
            volume
            volumeUnit
          }
        }
      }
    }
  }
  ${baseProductFragment}
  ${baseVariantFragment}
`;

export { GET_PRODUCTS_BY_SKUS };
//# sourceMappingURL=get-products-by-skus.js.map
